var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8762 13.875L15.75 15.75M15 10.875C15 8.5968 13.1532 6.75 10.875 6.75C8.5968 6.75 6.75 8.5968 6.75 10.875C6.75 13.1532 8.5968 15 10.875 15C13.1532 15 15 13.1532 15 10.875Z",
    stroke: "#BFBFBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.25H10.5M2.25 7.5V10.5M4.875 15.75C3.42525 15.75 2.25 14.5747 2.25 13.125M13.125 2.25C14.5747 2.25 15.75 3.42525 15.75 4.875M2.25 4.875C2.25 3.42525 3.42525 2.25 4.875 2.25",
    stroke: "#BFBFBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchArea);
export default __webpack_public_path__ + "static/media/search-area.2ce9691c044b20379e68a61ce629c02f.svg";
export { ForwardRef as ReactComponent };